import {UI} from "../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../stem-core/src/ui/Style";
import {merchantStyleRule} from "../Security";
import {isSmallScreen} from "../../UtilsLib";
import {iFrameState} from "../../services/IFrameState";
import {GATE_TYPE} from "../../../blink-sdk/Constants";
import {isString} from "../../../stem-core/src/base/Utils";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {PanelTypeToControllerClassMap} from "../flows/BasicFlowControllers";
import {MessageElement} from "../../widget/ui/MessageElement";


// TODO @cleanup remove this crap
class PanelTextStyle extends StyleSheet {
    @merchantStyleRule
    text = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
        width: "100%",
        margin: "18px 0px",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        textAlign: () => (isSmallScreen() || iFrameState.gateType === GATE_TYPE.banner) ? "left" : "center",
        ...iFrameState.textStyle,
    };
}

@registerStyle(PanelTextStyle)
export class PanelText extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.text);
    }

    setOptions(options) {
        if (Array.isArray(options.children) && !options.children.length) {
            const controllerClass = PanelTypeToControllerClassMap[iFrameState.panelType];
            options.children = controllerClass ? (new controllerClass()).getHeaderDefaultText() : [];
        }
        if (Array.isArray(options.children) && options.children.length === 1) {
            options.children = options.children[0];
        }
        if (Array.isArray(options.children) && !options.children.length) {
            options.children = iFrameState.panelText || "";
        }
        if (isString(options.children) || options.children instanceof UI.TextElement) {
            options.children = options.children.toString().split("\n").map(line => <div style={{minHeight: "1em"}}>
                <MessageElement message={line} />
            </div>);
        }
        return super.setOptions(options);
    }
}
